import { VARIANT } from "./variant";

export const PROMPT_TYPE = {
  ...VARIANT,
  CONFIRMATION: "confirmation",
  ERROR: "error",
  CONFIRMATION_DELETE: "confirmationDelete",
  CONFIRMATION_ERROR: "confirmationError",
  SUCCESS: "success",
};
